// extracted by mini-css-extract-plugin
export default {"commonButton":"commonButton_commonButton__DBqvy"};